import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { CustomCheckbox } from "../CustomCheckbox";
import { ReactNode } from "react";
type Props = {
  title: string;
  checked: boolean;
  disabled?: boolean;
  onClick: () => void;
  renderItem?: (item: string) => ReactNode;
  withCheckbox?: boolean;
};

export const DropdownSubItem = ({
  title,
  checked,
  disabled,
  onClick,
  renderItem = (item: string) => item,
  withCheckbox = true,
}: Props) => {
  return (
    <MenuItem
      disabled={disabled}
      sx={{
        padding: "4px",
      }}
      onClick={onClick}
    >
      {withCheckbox && <CustomCheckbox checked={checked} disableRipple />}

      <ListItemText
        primary={renderItem(title)}
        slotProps={{
          primary: {
            whiteSpace: "break-spaces",
          },
        }}
      />
    </MenuItem>
  );
};
